import { z } from 'zod';

/**
 * Política de senha — espelha a validação do backend
 * (`backend/src/auth/dto/auth.dto.ts`). Validar no cliente é conveniência:
 * quem decide é o servidor.
 */
export const MENSAGEM_SENHA =
  'A senha deve ter no mínimo 10 caracteres, com ao menos uma letra maiúscula, ' +
  'uma minúscula e um número.';

export const esquemaSenha = z
  .string()
  .min(10, MENSAGEM_SENHA)
  .max(128, 'A senha pode ter no máximo 128 caracteres.')
  .regex(/[a-z]/, MENSAGEM_SENHA)
  .regex(/[A-Z]/, MENSAGEM_SENHA)
  .regex(/\d/, MENSAGEM_SENHA);

export interface ForcaSenha {
  pontos: number;
  rotulo: string;
  criterios: { texto: string; atendido: boolean }[];
}

/**
 * Avalia a senha contra os critérios exigidos, para dar retorno imediato
 * enquanto o usuário digita.
 */
export function avaliarSenha(senha: string): ForcaSenha {
  const criterios = [
    { texto: 'Ao menos 10 caracteres', atendido: senha.length >= 10 },
    { texto: 'Uma letra minúscula', atendido: /[a-z]/.test(senha) },
    { texto: 'Uma letra maiúscula', atendido: /[A-Z]/.test(senha) },
    { texto: 'Um número', atendido: /\d/.test(senha) },
  ];

  const atendidos = criterios.filter((criterio) => criterio.atendido).length;
  const bonus = senha.length >= 14 ? 1 : 0;
  const pontos = atendidos + bonus;

  const rotulo = atendidos < criterios.length ? 'Incompleta' : bonus > 0 ? 'Forte' : 'Aceitável';

  return { pontos, rotulo, criterios };
}
